module.exports = __webpack_public_path__ + "img/shegou_logo.5a571758.png";